import { InfoIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Image
} from "@chakra-ui/react";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { WBToken } from "../app/index";
import { HelpBanner } from "../components/helpBanner/helpBanner";
import { User } from "../components/user/user";
import { useHelpBanner } from "../hooks/useHelpBanner";
import { useAppConfig } from "../hooks/useAppConfig";

export const MenuHeader = (user: WBToken) => {
  const { helpBtnRef, helpIsOpen, helpOnOpen, helpOnClose } = useHelpBanner();
  const { ctaColor, logoUrl, ctaTextColor, secondaryColor, primaryColor } = useAppConfig();
  const navigate = useNavigate();

  // Handler per navigare alla homepage al click del logo
  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <Flex 
      h={["60px", "100px"]}
      w="100%"
      align="center"
      justify="space-between"
      p={[1, 0]}
      borderColor={`${primaryColor}.0.8`}
      borderStyle="solid"
      borderBottomWidth="1px"
    >
      <Box>
        <Image
          m={["0.25rem", "0.5rem"]}
          ml={["0.5rem", "2rem"]}
          src={logoUrl}
          w={["4rem", "8rem"]}
          cursor="pointer"
          onClick={handleLogoClick}
          transition="transform 0.2s"
          _hover={{
            transform: "scale(1.05)",
          }}
          _active={{
            transform: "scale(0.95)",
          }}
        />
      </Box>
      <Box p={[1, 5]}>
        <ButtonGroup
          variant="ghost"
          spacing={["1", "3"]}
        >
          <Button bgColor={ctaColor}
            color={ctaTextColor}
            leftIcon={<InfoIcon />}
            ref={helpBtnRef}
            onClick={helpOnOpen}
            fontSize={["xs", "sm", "md"]}
            size={["xs", "sm"]}
          >
            Aiuto
          </Button>
          {user && <User {...user} />}
        </ButtonGroup>
        <HelpBanner
          isOpen={helpIsOpen}
          onClose={helpOnClose}
          btnRef={helpBtnRef}
        />
      </Box>
    </Flex>
  );
};
